import React from "react";
import "./banner.scss";
const Banner = () => {
  return (
    <>
      <section className="mainbanner" id="home">
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/assets/bannerassets/luckifybg.mp4" type="video/mp4" />
        </video>
        <img
          src="/assets/bannerassets/bannertopshade.png"
          alt="bannertopshade"
          className="bannertopshade"
        />
            {window.innerWidth < 991 ?
        <img
          src="/assets/bannerassets/bannerlinesmbl.png"
          alt="bannerlines"
          className="bannerlines"
        />
        :
            <img
          src="/assets/bannerassets/bannerlines.png"
          alt="bannerlines"
          className="bannerlines"
        />
            }
        <span className="bottomshade"></span>
        <div className="custom-container">
          <div className="innerbanner">
            <span className="bannerspan">
            Provably fair. On-chain. Trustless.
            </span>
            <h2 className="bannerhead">Trustless Gaming Starts Now</h2>
            <p className="bannerpara">
              The future of gaming is cryptographic and decentralized. Luckify
              brings tamper-proof randomness to betting, loot boxes, and more —
              powered by Chainlink VRF and the LUCK token.
            </p>
            <a
              href="https://app.luckify.bet/"
              target="_blank"
              className="bannerbtn"
            >
              LAUNCH APP
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
